import React from "react";
import "./share-collection.m.css";
import Whatsapp from "../../atoms/social-media-icons/Whatsapp";
import Facebook from "../../atoms/social-media-icons/Facebook";
import Twitter from "../../atoms/social-media-icons/Twitter";
import Telegram from "../../atoms/social-media-icons/Telegram";
import LinkedIn from "../../atoms/social-media-icons/LinkedIn";
import Mail from "../../atoms/social-media-icons/Mail";

const SOCIAL_MEDIA_SHARE = [
  {
    name: "whatsapp",
    type: "whatsapp_round",
    bgColor: "##FFFFFF",
    icon: <Whatsapp width="19" height="19" color="#25D366" />
  },
  {
    name: "facebook",
    type: "facebook_round",
    bgColor: "#FFFFFF",
    icon: <Facebook width="19" height="19" color="#0866FF" />
  },
  {
    name: "twitter",
    type: "twitter_round",
    bgColor: "#FFFFFF",
    icon: <Twitter width="19" height="19" color="black" />
  },
  {
    name: "telegram",
    type: "telegram_round",
    bgColor: "#FFFFFF",
    icon: <Telegram width="19" height="19" color="#2396D0" />
  },
  {
    name: "linkedin",
    type: "linkedin_round",
    bgColor: "#FFFFFF",
    icon: <LinkedIn width="19" height="19" color="#2867B2" />
  },
  {
    name: "mail",
    type: "mail_round",
    bgColor: "#FFFFFF",
    icon: <Mail width="19" height="19" color="#1C1B1F" />
  }
];

const socialMediaUrl = (type) => {
  const publishedURL = window.location.href;
  const encodedText = `Read more`;
  let url;

  switch (type) {
    case "facebook":
      url = `http://en-gb.facebook.com/sharer/sharer.php?utm_source=prajavani&utm_medium=facebook&u=${encodeURIComponent(
        publishedURL + "?utm_source=facebook&utm_medium=referral&utm_campaign=socialshare"
      )}&t=${encodedText}`;
      break;
    case "twitter":
      url = `https://twitter.com/intent/tweet?utm_source=prajavani&utm_medium=twitter&url=${encodeURIComponent(
        publishedURL + "?utm_source=twitter&utm_medium=referral&utm_campaign=socialshare"
      )}&text=${encodedText}&via=prajavani`;
      break;
    case "whatsapp":
      url = `https://api.whatsapp.com/send?utm_source=prajavani&utm_medium=whatsapp&text=${encodedText} ${encodeURIComponent(
        publishedURL + "?utm_source=whatsapp&utm_medium=referral&utm_campaign=socialshare"
      )}`;
      break;
    case "linkedin":
      url = `http://www.linkedin.com/shareArticle?utm_source=prajavani&utm_medium=linkedin&mini=true&title=${encodedText}
      &url=${encodeURIComponent(publishedURL + "?utm_source=linkedin&utm_medium=referral&utm_campaign=socialshare")}`;
      break;
    case "mail":
      url = `mailto:?subject=${encodedText}&body=${encodedText}:%20${encodeURIComponent(
        publishedURL + "?utm_source=mail&utm_medium=referral&utm_campaign=socialshare"
      )}`;
      break;
    default:
      url = "";
      break;
  }
  return url;
};

const ShareCollection = () => {
  return (
    <div styleName="social-wrapper">
      <span styleName="triangle"></span>
      {SOCIAL_MEDIA_SHARE.map((share, index) => (
        <a key={index} target="_blank" rel="nofollow noreferrer" href={socialMediaUrl(share.name)}>
          {share.icon}
        </a>
      ))}
    </div>
  );
};

export default ShareCollection;
